import React from 'react'
import './Footer.css'
import {CiFacebook, CiInstagram} from "react-icons/ci"

export default function Footer() {
  return (
    <>
    <div className='footer' id='footer'>
        <div className="footer-content">
            <div className="footer-content-left">
                <h1>MAHIKA CAFE</h1>
                <p>“Mahika Café” brewing magic in every cup, is a whimsical and enchanting coffee haven where the ordinary transcends into the extraordinary. From the moment you step through its shimmering door, you’re greeted by the rich aroma of freshly brewed beans and walls adorned with celestial murals. The baristas, akin to alchemists, perform their spellwork behind the counter, creating brews that defy time and imagination. The hidden courtyard invites contemplation, while antique bookshelves hold forgotten tales. Here, every cup holds a touch of wonder, and every corner whispers a secret waiting to be discovered.</p>
            </div>
            <div className="footer-content-center">
                <h2>COMPANY</h2>
                <ul>
                    <li>Home</li>
                    <li>About Us</li>
                    <li>Privacy Policy</li>
                </ul>
            </div>
            <div className="footer-content-right">
                <h2>GET IN TOUCH</h2>
                <div className="social">
                <a href="https://www.facebook.com/mahikacafemalvar"><CiFacebook size={60} color="white" /> </a>
                <a href="https://www.instagram.com/mahikacafe?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><CiInstagram size={60} color="white"/></a>
                </div>
                <p>321 G Leviste St. Poblacion, Malvar, Batangas near BSU Malvar</p>
            </div>
        </div>
        <hr />
        <p className="footer-copyright">Copyright 2024 @ MahikaCafe.com - All Right Reserved.</p>
    </div>
    </>
  )
}
